function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.5227 8.77148H13.8447V6.69236H18.5227V8.77148Z",
  fill: "#D7D6E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.1087 8.77148H21.4307V6.69236H26.1087V8.77148Z",
  fill: "#D7D6E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.84183 8.77144C9.23875 8.77144 8.74807 9.26212 8.74807 9.86525V10.9048H6.66895V9.86525C6.66895 8.11566 8.09223 6.69231 9.84183 6.69231H10.8814V8.77144H9.84183Z",
  fill: "#D7D6E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.2026 10.9048V9.86525C31.2026 9.26212 30.712 8.77144 30.1089 8.77144H29.0693V6.69231H30.1089C31.8585 6.69231 33.2818 8.11566 33.2818 9.86525V10.9048H31.2026Z",
  fill: "#D7D6E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.5227 33.3074H13.8447V31.2282H18.5227V33.3074Z",
  fill: "#D7D6E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.1087 33.3074H21.4307V31.2282H26.1087V33.3074Z",
  fill: "#D7D6E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.84188 33.3074C8.09229 33.3074 6.66895 31.884 6.66895 30.1344V29.0949H8.74807H8.74812V30.1344C8.74812 30.7376 9.23875 31.2282 9.84188 31.2282H10.8814V33.3074H9.84188Z",
  fill: "#D7D6E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.1089 33.3074H29.0693V31.2282H30.1089C30.7119 31.2282 31.2026 30.7376 31.2026 30.1344V29.0949H33.2818V30.1344C33.2818 31.884 31.8585 33.3074 30.1089 33.3074Z",
  fill: "#D7D6E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.74612 18.2861H6.66699V13.6081H8.74612V18.2861Z",
  fill: "#D7D6E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.74612 25.8726H6.66699V21.1946H8.74612V25.8726Z",
  fill: "#D7D6E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.333 18.2861H31.2539V13.6081H33.333V18.2861Z",
  fill: "#D7D6E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.333 25.8726H31.2539V21.1946H33.333V25.8726Z",
  fill: "#D7D6E0"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 26.6667,
  height: 26.6667,
  fill: "white",
  transform: "matrix(1 0 0 -1 6.66699 33.3333)"
})));

var SvgSquare = function SvgSquare(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSquare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/square.34baf44d.svg";
export { ForwardRef as ReactComponent };